import { Field } from "formik";
import React, { useEffect, useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT, addActiveFn,
  pushToParams,
  requestTo
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import { Accordion, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import request from "../../services/request";
import { useTranslation } from 'react-i18next';
import DemandUpdate from "../home/demand-update/DemandUpdate";
import FileUpload from "../../components/fields/FileUpload";
import {formatDate} from "../../utils";                   /* Added Line */

export default function InfoBanksCategories(props) {
  const [showModal, setShowModal] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);
  const [topCategories, setTopCategories] = useState([]);
  const [refreshList, setRefreshList] = useState(false);
  const [refreshFileList, setRefreshFileList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isFileUpdating, setIsFileUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [initialValuesFile, setInitialValuesFile] = useState({id: null});
  const [selectedRow, setSelectedRow] = useState(null);
  const [ghibBaskani, setGhibBaskani] = useState(false);
  const [t, i18n] = useTranslation();         /* Added Line */
  const [configData, setConfigData] = useState(null);
  const [fileValidation, setFileValidation] = useState(false);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    request({
      url: "user/info",
      method: "GET",
    }).then((response) => {
      setGhibBaskani(response.body.ghibBaskan);
      setRefreshList(!refreshList);
    });
  }, [ghibBaskani]);

  const getTopCategories = () => {
    request({
      url: "bilgi-bankasi/list",
      method: "POST",
      data: {
        body: {
          "sortOrder": "DESC", "pageIndex": 0, "pageSize": 10000, "filters": []
        }
      },
    }).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setTopCategories(response.body.tableData.filter(v => v.parentId === null).map(tc => { return { value: tc.id || '', label: tc.name || tc.parentName || '' } }))
      }
    });;
  }

  useEffect(() => {
    getTopCategories();
  }, [refreshList]);


  const validationSchema = yup.object({
    name: yup.string().required("Gerekli alan."),
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      name: values.name,
      parentId: values.parentId,
      id: values.id,
      stId: values.stId || 90,
      ghibBaskaniMi: true,
      fileId: values.fileId ,
    };
    return payload;
  };
  const mapDataBeforeList = (row) => {
    row.ghibBaskaniMi = ghibBaskani;
    return row;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      name: data.name,
      parentId: data.parentId,
      id: data.id,
      stId: data.stId,
      fileId: data.fileId,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);

    /*if (topCategories.length === 0) {
      getTopCategories();
    }


     */
  };

  const arrangeBeforePersistFile = (values) => {
    let payload = {
      bilgiBankasiId: selectedRow.id,
      descr: values.descr
    };
    
    if (values.fileId && values.fileId.length) {
      payload.fileId = values.fileId[0].id;
      payload.path = values.fileId[0].path;
    }
    
    return payload;
  };

  const validateDataAfterSubmit = (values) => {
    setFileValidation(values && !values.fileId);
    return values.fileId;
  }

  const adaptDataForUpdateFile = (data) => {
    setInitialValuesFile(data.tableData.map(tc => { return { id: tc.id, fileId: tc.fileId , descr: tc.descr, filename: tc.filename } }))

  };
  const onFileUpdateButtonClicked = (selectedRow) => {
    setShowFileModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
    //setInitialValuesFile({id: null, files: null});
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});

    if (topCategories.length === 0) {
      getTopCategories();
    }
  };
  const onAddFileButtonClicked = () => {
    setShowFileModal(true);
    setIsFileUpdating(false);
    setInitialValues({});

  };
  return (

    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="bilgi-bankasi/config"
                    //configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="parentId"
                      label={t("infoBanksCategories.ustKategori")}
                      colNumber="6"
                      oper="EQ"
                      component={Select}
                      placeholder={t("formFields.allPlaceHolder")}
                      options={configData && configData.ustKategoriler}
                    />
                    <Field
                      name="name"
                      label={t("infoBanksCategories.kategoriAdi")}
                      colNumber="3"
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                      component={TextInput}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("pageTitleofDemandCreate.bilgiBankasiKategori")}
            unscrollable
          >
            <FormikForm
                isUpdating={isUpdating}
              endPointUrl="bilgi-bankasi/create"
              fetchPointUrl="bilgi-bankasi/find"
              editPointUrl="bilgi-bankasi/update"
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              //configPointUrl="bilgi-bankasi/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              secondSubmitButttonText={t(
                 "actionButtonGenerator.tamamla"
              )}
              //setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => {
                  getTopCategories();
                  setRefreshList(!refreshList)
                }
              }
            >
              <Field
                name="parentId"
                label={t("infoBanksCategories.ustKategori")}
                colNumber="12"
                component={Select}
                options={topCategories}
              />
              <Field
                name="name"
                label={t("infoBanksCategories.kategoriAdi")}
                colNumber="12"
                component={TextInput}
                required
              />
            </FormikForm>
          </CrudMain>

        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="bilgi-bankası-kategoriler"
            endpoint="bilgi-bankasi/list"
            keyField="id"
            refreshList={refreshList}
            mapDataBeforeList={mapDataBeforeList}
            columns={[

              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header"
              },
              {
                dataField: "parentName",
                text: `${t("demandList.ustKategoriAdi")}`,
                sort: true,
              },{
                dataField: "name",
                text: `${t("demandList.kategoriAdi")}`,
                sort: true,
              },
            ]}
            customBody={{
              filters: filters,
            }}
            onDelete={ (api) => { 
                api.getData();
                getTopCategories();
              }
            }
            actionButtonsObject= {{
              actions: [

                 pushToParams(ABT.EDIT, onUpdateButtonClicked),

                addActiveFn(
                    pushToParams(ABT.UPLOAD_BUTTON, onFileUpdateButtonClicked),
                    (row)=> {
                      return (row.ghibBaskan && row.parentId!=null)
                    }
              ),
                requestTo(ABT.DELETE, "bilgi-bankasi/delete"),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 col-xl-12 col-xxl-12">
          <CrudMain
              showModal={showFileModal}
              setShowModal={setShowFileModal}
              title={t("pageTitleofDemandCreate.bilgiBankasiFiles")}
              hideNewAddButton
          >
            <FormikForm
                isUpdating={isUpdating}
                entityId={selectedRow && selectedRow.id}
                entityFetchId="id"
                endPointUrl="bilgi-bankasi/dokuman-ekle"
                //fetchPointUrl="bilgi-bankasi/get-files"
                editPointUrl="bilgi-bankasi/dokuman-ekle"
                arrangeBeforePersist={arrangeBeforePersistFile}
                adaptDataForUpdate={adaptDataForUpdateFile}
                //validateDataAfterSubmit={validateDataAfterSubmit}
                initialValues={initialValuesFile}
                //closeModal={() => setShowFileModal(false)}
                refreshList={() => setRefreshFileList(!refreshFileList)}
                resetAfterSubmit={true}
            >
              <Field
                  name="descr"
                  label={t("demandList.aciklama")}
                  colNumber="6"
                  component={TextInput}
                  required
              />
              <Field
                  name="fileId"
                  label="Dosya"
                  colNumber="12"
                  component={FileUpload}
                  //requiredShow={fileValidation}
                  //required
              />
            </FormikForm>

            <ListComponent
                selectedRows={selectedRow}
                entityName=""
                endpoint="bilgi-bankasi/get-files"
                keyField="id"
                fileNameField="fileName"
                customBody={{
                  'id': selectedRow && selectedRow.id
                }}
                refreshList={refreshFileList}
                columns={[
                  {
                    dataField: "descr",
                    text: t("demandList.aciklama"),
                    sort: true,
                  },
                  {
                    dataField: "fileName",
                    text: t("tabs.dosyaAdi"),
                    sort: true,
                  } ,{
                    dataField: "createdDate",
                    text: t("tabs.tarih"),
                    formatter: formatDate,
                    sort: true,
                  },
                  {
                    dataField: "cuser.fullName",
                    text: t("tabs.ekleyen"),
                    sort: true,
                  },
                ]}
                actionButtonsObject={
                  ({
                    actions: [
                      requestTo(ABT.DELETE, "bilgi-bankasi-file/delete"),
                      requestTo(ABT.DOWNLOAD, "bilgi-bankasi-file/download")
                    ],
                    generator: DefaultActionButtonGenerator,
                  })
                }
            />
          </CrudMain>

        </div>
      </div>
    </Main>
  );
}
